import React, { useState } from 'react'
import { useSystemSettings } from 'react-omnitech-api'
import _ from 'lodash'
import PropTypes from 'prop-types'
import SocialMediaView from './social-media-view'
import getSocialMediaOptions from '../../helpers/get-social-media-options'

const SocialMediaController = (props) => {
  const [show, setShow] = useState(false);
  const { getSystemSetting } = useSystemSettings()
  const {
    text,
    marginIcon,
    scale,
    title,
    imageUrl,
    hashtags,
    classN,
    shareUrl,
  } = props

  const shareOption = getSocialMediaOptions(shareUrl, title, imageUrl, hashtags)
  const socialMediaActive = _.forEach(shareOption, (value, key) => Object.assign(shareOption, {
    [key]: {
      isActive: !!getSystemSetting(`social_sharer.enable_${key}`),
      ...value,
    },
  }))
  const hasAnySocialMediaActive = _.includes(_.reduce(socialMediaActive, (result, value) => {
    if (value.isActive) result.push(value.isActive)
    return result
  }, []), true)

  function handleShare(provider) {
    const shareProvider = shareOption[provider]
    const params = _.map(_.keys(shareProvider.options), (key) => (
      `${key}=${encodeURIComponent(shareProvider.options[key])}`
    ))
    const providerUrl = shareProvider.url
    const joiner = providerUrl.indexOf('?') !== -1 ? '&' : '?'
    const sharerFullUrl = `${providerUrl}${joiner}${params.join('&')}`
    window.open(
      sharerFullUrl,
      provider === 'email' ? '_self' : '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=400, height=400',
    )
  }

  function copyToClipboard() {
    setShow(true)
    navigator.clipboard.writeText(shareUrl)
    setTimeout(() => {
      setShow(false);
    }, 1000);
  }

  const viewProps = {
    text,
    show,
    marginIcon,
    scale,
    classN,
    socialMediaActive,
    hasAnySocialMediaActive,
    onShare: handleShare,
    copyToClipboard,
  }

  return (
    <SocialMediaView {...viewProps} />
  )
}
SocialMediaView.propTypes = {
  text: PropTypes.string,
  classN: PropTypes.string,
}
SocialMediaView.defaultProps = {
  text: 'SHARE',
  marginIcon: '1rem 2rem 0 1.5rem',
  classN: '',
}
export default SocialMediaController
